export default __webpack_public_path__ + "static/media/branding-mediumitalic-webfont.190f62e6.woff2";